import { CgArrowLeft } from 'react-icons/cg';
import { Link } from 'react-router';
import { TbFaceIdError } from 'react-icons/tb';

import { Button } from '@/components/Button';

export function ScenarioNotFound() {
  return (
    <div
      data-testid="not-found"
      className="flex-1 relative right-side text-white py-10 px-6 flex flex-col items-center justify-center gap-8 min-h-[60svh]"
    >
      <div className="absolute top-5 left-5">
        <Button
          mini
          to="/demo"
          component={Link}
          variant="outline"
          icon={<CgArrowLeft size={18} />}
          className="text-white border-white/50 hover:bg-white hover:text-black"
        />
      </div>

      <div className="text-center space-y-6 max-w-md">
        <div className="space-y-4">
          <div className="w-24 h-24 mx-auto bg-white/10 rounded-full flex items-center justify-center">
            <TbFaceIdError size={48} />
          </div>
          <h1 className="text-3xl font-bold">Scenario Not Found</h1>
          <p className="text-white/70 text-lg leading-relaxed">
            The scenario you're looking for doesn't exist or may have been removed.
          </p>
        </div>

        <div className="space-y-4">
          <Button to="/demo" component={Link} label="Back to Scenarios" className="w-full" />
          <p className="text-white/50 text-sm">Choose from our available scenarios to start practicing</p>
        </div>
      </div>
    </div>
  );
}
